<template>
  <div>
    <h1>Audits</h1>
    <datatable
      :data="tableData"
      :no-results="'No audits'"
      :loading="loading"
      :updatingRow="updatingAuditId"
    />

    <sidepanel v-if="selectedAudit" :onClose="onClosePreview">
      <h3>Audit {{selectedAudit.id}} changes</h3>
      <pre>{{selectedAudit.diff}}</pre>
    </sidepanel>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Axios from 'axios';
  import { API_HOST } from '@/config/app-const';
  import Datatable from '@/components/datatable';
  import Sidepanel from '@/components/side-panel';

  export default {
    data: function() {
      return {
        loading: false,
        audits: [],
        updatingAuditId: null,
        selectedAudit: null
      }
    },

    mounted () {
      this.$emit('setHeaderPrimaryName', this.project.project_name);
      this.loading = true;
      this.fetchAudits().then(response => {
        this.audits = response.data.data || [];
        this.loading = false;
      });
    },

    computed: {
      ...mapState({
        user: state => state.user.user.data,
        project: state => state.projects.project.data
      }),

      projectId () {
        return this.project.project_id;
      },

      tableData () {
        const columns = [
          {
            key: 'id',
            label: 'Audit ID', width: '200px',
            render: (row) => {
              return (<a href="#" onClick={(e) => this.previewAudit(e, row)}>{row.id}</a>)
            }
          },
          {
            key: 'created_by',
            label: 'Created By'
          },
          {
            key: 'created_at',
            label: 'Created At'
          },
          {
            key: 'article_ids',
            label: 'Articles',
            render: (row) => {
              return row.article_ids && row.article_ids.join(', ');
            },
            cellStyle: {
              'max-width': '200px'
            }
          },
          {
            key: 'category_ids',
            label: 'Categories',
            render: (row) => {
              return row.category_ids && row.category_ids.join(', ');
            },
            cellStyle: {
              'max-width': '200px'
            }
          },
          {
            key: 'tag_ids',
            label: 'Tags',
            render: (row) => {
              return row.tag_ids && row.tag_ids.join(', ');
            },
            cellStyle: {
              'max-width': '200px'
            },
          },
          {
            key: 'source_ids',
            label: 'Sources',
            render: (row) => {
              return row.source_ids && row.source_ids.join(', ');
            },
            cellStyle: {
              'max-width': '200px'
            }
          },
          {
            key: 'grouping_ids',
            label: 'Groupings',
            render: (row) => {
              return row.grouping_ids && row.grouping_ids.join(', ');
            },
            cellStyle: {
              'max-width': '200px'
            }
          },
          {
            key: 'reverted_by_audit_id',
            label: 'Reverted By Audit ID',
            cellStyle: {
              'max-width': '200px'
            }
          }
        ]
        if ([357, 694].indexOf(this.user.id) > -1) {
          columns.push(
            {
              render: (row) => {
                const disabled = !row.can_revert;
                return <button disabled={disabled} onClick={() => this.onRevert(row.id)}>Revert</button>
              }
            }
          )
        }

        return {
          body: this.audits,
          columns: columns
        }
      },

      requestsConfig () {
        const accessToken = this.user.accessToken;
        const config = {
          headers: { Authorization: `Token token=${accessToken}` }
        };
        return config;
      }
    },

    methods: {
      fetchAudits () {
        const url = `${API_HOST}/analysis/${this.projectId}/audits`;
        const config = this.requestsConfig;
        return Axios.get(url, config);
      },

      onRevert (auditId) {
        this.updatingAuditId = auditId;
        return this.revertAudit(auditId).then(r => {
          this.$notify({
            group: 'store_notifications',
            type: 'success',
            text: 'Audit ' + auditId + ' reverted.',
          });
          this.updatingAuditId = null;
          this.loading = true;
          this.fetchAudits().then(response => {
            this.audits = response.data.data || [];
            this.loading = false;
          });
        });
      },

      revertAudit(auditId) {
        const url = `${API_HOST}/analysis/${this.projectId}/audits/${auditId}`;
        const config = this.requestsConfig;
        return Axios.delete(url, config);
      },

      previewAudit(e, audit) {
        e.preventDefault();
        this.selectedAudit = audit;
      },

      onClosePreview() {
        this.selectedAudit = null;
      }
    },

    components: {
      Datatable,
      Sidepanel
    }
  };
</script>
